:host {
  @apply block;
}

::slotted(img) {
  @apply w-full h-full object-cover;
}

::slotted(picture) {
  @apply flex w-full h-auto overflow-hidden;
}

:host([media-position="right"]) {
  ::slotted(img),
  ::slotted(picture) {
    @apply rounded-none md:rounded-[5px];
  }
}


:host([media-position="right"]) {
  ::slotted(img),
  ::slotted(picture) {
    @apply rounded-none md:rounded-[5px];
  }
}
